export class SummedMasterReport {
  time?: string;
  day?: string;
  adRequests?: number;
  revenue?: number;
  dfpRevenue?: number;
  dpRevenue?: number;
  adxRevenue?: number;
  dfpDpDiff?: number;
  dfpDpDiffPercent?: number;
  passbackRevenue?: number;
  sbImpressions?: number;
  sbDomain?: string;
  sbRequests?: number;
  daysActive?: number;
  dfpEbdaRevenue?: number;
  dfpEbdaVideoRevenue?: number;
  combinedRevenue?: number;
  combinedImpressions? :number;

  ebAssociatedPublisherName?: number;
  netRevenue?: number;
  activityStatus?: string;
  url?: string;
  salesRepresentativeEmail?: string;
  accountManagerEmail?: string;
  impressions?: number;
  rpm?: number;
  ioCpm?: number;
  revSharePercent?: number;
  margin?: number;
  inViewTotal?: number;
  filled?: number;
  refreshRate?: number;
  publisherNetRevenue?: number;
  dpApprovals?: number;
  dpApprovalsOk?: number;

  videoUnit?: boolean;
  bidder?: boolean;
  bidderCalc?: boolean;
  bridgeAdUnitName?: string;
  companionAdUnitId?: string;
  bridgeAdUnitId?: string;
  publisherName?: string;
  adsTxtMissingRecords?: number;
  publisherId?: string;
  siteId?: string;
  publisherGrossRevenue?: number;
  bidderRevsharePercent?: number;

  ui_ioCpmRpmDiff?: number;
  campaignId: number;
  adsTxtStatus: string;

  overbid?: number;
  constantBid?: number;
}
